import React from 'react';
import 'CSS/demand-supply/demand-supply.scss';
import 'CSS/dashboard-statistic.scss';
import 'CSS/dashboard-tickets.scss';
import 'CSS/dashboard-slips.scss';
import Grid from '@material-ui/core/Grid';

import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import AvatarUser from 'Demand/components/AvatarUser';

export const Comment = ({
  user,
  handleChange,
  handleBlur,
  comment,
  errors,
  touched,
}) => {
  return (
    // <Grid item xs={12} className="u-pad-8  height-100p">
    <Grid container className="u-pad-bot-10 u-pad-r-8 u-pad-l-8">
      <Grid item xs={6}>
        <h2 className="t-primary-16 t-weight-b u-mrg-bot-10 u-mrg-top-10">
          Respond to supplier
        </h2>
      </Grid>
      {/* <AvatarUser user={user} /> */}
      <Grid container className="t-primary-14 c-gray-light comment-section">
        <FormControl fullWidth className="u-mrg-left-5 u-mrg-r-5">
          <InputLabel
            classes={{
              root: 'label--c-gray',
            }}
          >
            Add response
          </InputLabel>
          <Input
            multiline
            name="comment"
            onChange={handleChange}
            onBlur={handleBlur}
            value={comment}
            error={!!(errors.comment && touched.comment)}
            classes={{
              underline: 'underline--c-black',
            }}
          />
          {errors.comment && touched.comment && (
            <FormHelperText error>{errors.comment}</FormHelperText>
          )}
        </FormControl>
      </Grid>
    </Grid>
    // </Grid>
  );
};
